import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-[#1a0d2e] border-y border-[#3a2456]" data-id="element-111">
      <div className="container mx-auto px-4 text-center" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-[#0d0716]/80 rounded-3xl p-8 md:p-12 shadow-2xl border border-slate-400/20" data-id="element-113">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#130a22]/50 text-slate-300 mb-6 border border-slate-400/30" data-id="element-114">
            <ShieldCheck className="w-10 h-10" data-id="element-115" />
          </div>

          <h2 className="text-3xl font-extrabold text-white mb-4" data-id="element-116">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-slate-300 mb-6" data-id="element-117">
            Abrís los tomos. Los usás. Si en 7 días no es lo que esperabas:
          </p>

          <div className="bg-[#130a22]/50 text-slate-200 font-bold text-xl py-4 px-6 rounded-xl mb-6 border border-slate-400/30" data-id="element-118">
            Devolución del 100% sin formularios, sin drama.
          </div>

          <p className="text-sm text-slate-400 font-medium uppercase tracking-wider" data-id="element-119">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}